import styles from './MonitorAvailabilityChart.module.scss'

interface AvailabilityResultSetProps {
  x: string
  y: number
  status: string
  runId: number
}

const maxBarWidth = 50 // the UOM that is using is in 'px' for react-chart-js-2

const extractLabels = (resultsets: AvailabilityResultSetProps[]) => resultsets.map(resultset => resultset.x)

const getTestResultsByStatus = (resultsets: AvailabilityResultSetProps[], status: string) => resultsets.filter(resultset => resultset.status === status)

export const generateChartData = (
  availabilityResultSet: AvailabilityResultSetProps[],
  minBarWidth: number
) => ({
  labels: extractLabels(availabilityResultSet), // sequential x-axis contents
  datasets: [
    {
      label: 'Passed',
      data: getTestResultsByStatus(availabilityResultSet, 'PASSED'),
      parsing: {
        yAxisKey: 'y'
      },
      backgroundColor: styles.colorpass,
      maxBarThickness: maxBarWidth,
      barThickness: minBarWidth
    },
    {
      label: 'Failed',
      data: getTestResultsByStatus(availabilityResultSet, 'FAILED'),
      parsing: {
        yAxisKey: 'y'
      },
      backgroundColor: styles.colorfail,
      maxBarThickness: maxBarWidth,
      barThickness: minBarWidth
    },
    {
      label: 'Error',
      data: getTestResultsByStatus(availabilityResultSet, 'ERROR'),
      parsing: {
        yAxisKey: 'y'
      },
      backgroundColor: styles.colorerror,
      maxBarThickness: maxBarWidth,
      barThickness: minBarWidth
    },
    {
      label: 'Cancelled',
      data: getTestResultsByStatus(availabilityResultSet, 'CANCELLED'),
      parsing: {
        yAxisKey: 'y'
      },
      backgroundColor: styles.colorcancelled,
      maxBarThickness: maxBarWidth,
      barThickness: minBarWidth
    },
    {
      label: 'InProgress',
      data: getTestResultsByStatus(availabilityResultSet, 'INCOMEPLETE'),
      parsing: {
        yAxisKey: 'y'
      },
      backgroundColor: styles.colorinprogress,
      maxBarThickness: maxBarWidth,
      barThickness: minBarWidth
    }
  ]
})
